import { render, staticRenderFns } from "./Wlogo.vue?vue&type=template&id=0869bf3a&scoped=true&"
import script from "./Wlogo.vue?vue&type=script&lang=js&"
export * from "./Wlogo.vue?vue&type=script&lang=js&"
import style0 from "./Wlogo.vue?vue&type=style&index=0&id=0869bf3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0869bf3a",
  null
  
)

export default component.exports